import { AddExperienceForm } from '@/components/dashboard/AddExperienceForm';

export default function HostAddExperience() {
  return <AddExperienceForm />;
}
